// @flow

import { handleMapRequest } from '../phasedActionHelpers';

import type { LoadAlbumsAction } from '../../actions/album';

export type State = {
  +[key: string]: {|
    +entities: Array<string>,
    +loaded: boolean,
    +loading: boolean,
    +meta: { +count: number },
  |},
};

const initialState = {};

export default function albumsByRecording(
  state: State = initialState,
  action: LoadAlbumsAction
): State {
  if (action.type === 'FETCH_ALBUMS' && action.cacheId) {
    return handleMapRequest(state, action, action.cacheId);
  }

  return state;
}
